<template>
  <svg width="52" height="52" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.794 27.274a2.6 2.6 0 0 0-2.367 1.56 10.403 10.403 0 1 0 1.43 16.646 2.6 2.6 0 1 0-3.432-3.901 5.202 5.202 0 0 1-3.434 1.3 5.202 5.202 0 1 1 2.601-9.753h-.572a2.6 2.6 0 0 0 0 5.202h5.774a2.6 2.6 0 0 0 2.6-2.601v-5.852a2.6 2.6 0 0 0-2.6-2.601zm8.895-12.432a18.206 18.206 0 0 0-34.747 4.916 10.403 10.403 0 0 0-.989 19.922c.27.083.55.127.833.13a2.634 2.634 0 0 0 .832-5.202 5.202 5.202 0 0 1-3.433-4.733 5.202 5.202 0 0 1 5.201-5.202 2.6 2.6 0 0 0 2.601-2.6 13.004 13.004 0 0 1 25.307-4.188 2.6 2.6 0 0 0 2.028 1.743 7.803 7.803 0 0 1 2.601 14.382 2.61 2.61 0 1 0 2.6 4.526A13.004 13.004 0 0 0 52 27.274a13.004 13.004 0 0 0-9.311-12.432z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
